import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css'; // 注释掉全局样式，测试是否解决样式冲突问题
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);